import React, { useEffect } from 'react';
import { LANG, META_DESCRIPTION, META_PIXEL_ID, PAGE_TITLE, PIXEL_DRY_RUN } from './data/content';
import { initMetaPixel } from './utils/metaPixel';
import * as S from './components/Sections';

// ITALIENISCH VISUELL™ (DACH), 02/11. Modeled section by section on the Brazilian page "Italiano Visual Premium"
// (clubedamateria.com.br/italianovisual): same order, same path to the offer, same palette and type. Texts and images are ours.
// Kept from our rules: hero = title, sub, mockup and button; every button goes to the offer card; only the card goes to checkout;
// no fake urgency (their bar has dates and a countdown), no invented testimonials, 10-day guarantee.
// Content: data/content.ts · images: data/images.ts · pixel: data/pixel.ts.

const pixelNoscript = META_PIXEL_ID && !PIXEL_DRY_RUN ? `<img height="1" width="1" style="display:none" alt="" src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" />` : '';
export function App() {
  useEffect(() => {
    document.documentElement.lang = LANG;
    document.title = PAGE_TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = META_DESCRIPTION;
    initMetaPixel();
  }, []);
  return <div lang={LANG} className="min-h-screen w-full overflow-x-clip bg-cream font-sans text-ink antialiased" data-id="element-0" data-mp="2zlld2w2kqak3">
      {pixelNoscript && <noscript dangerouslySetInnerHTML={{
      __html: pixelNoscript
    }} data-id="element-1" data-mp="33ngfy505kvzz" />}
      <S.TopBar data-id="element-2" data-mp="38l8f9k34nke7" />
      <S.Hero data-id="element-3" data-mp="38kqfwel64q22" />
      <main data-id="element-4" data-mp="38k6vmr81ppkv">
        <S.Material data-id="element-5" data-mp="38nuorp9kw9z2" />
        <S.Zuhause data-id="element-6" data-mp="3dkuu1xylt8p4" />
        <S.Wo data-id="element-7" data-mp="3dle30p6a0mr0" />
        <S.Kapitel data-id="element-8" data-mp="3dlw6a5rcw18f" />
        <S.Warum data-id="element-9" data-mp="3dmfolnkx4rmz" />
        <S.Bekommst data-id="element-10" data-mp="3dirwmsv4gdad" />
        <S.Boni data-id="element-11" data-mp="nvj3xh1mugq9" />
        <S.FuerDich data-id="element-12" data-mp="nw2bq4xkjoqk" />
        <S.Offer data-id="element-13" data-mp="nuhjilyq8hvv" />
        <S.Garantie data-id="element-14" data-mp="nv12m6045cbh" />
        <S.Faq data-id="element-15" data-mp="nxwwnj8ubgun" />
        <S.Schluss data-id="element-16" data-mp="sudksdg1hv7q" />
      </main>
      <S.Footer data-id="element-17" data-mp="stko65asom3b" />
    </div>;
}